// Analytics utilities
export const trackEvent = (eventName, properties = {}) => {
  // GTM tracking
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...properties
    });
  }
  
  // Plausible tracking (if available)
  if (window.plausible) {
    window.plausible(eventName, { props: properties });
  }
  
  console.log('Event tracked:', eventName, properties);
};

export const trackPageView = (pageName, path) => {
  trackEvent('page_view', {
    page_name: pageName,
    page_path: path
  });
};

export const trackFormSubmission = (formName, formData = {}) => {
  trackEvent('form_submission', {
    form_name: formName,
    ...formData
  });
};

export const trackBookingInteraction = (interactionType = 'booking_initiated') => {
  trackEvent('booking_interaction', {
    interaction_type: interactionType,
    platform: 'google_calendar'
  });
};

// Lead service utilities
export const submitLead = async (leadData) => {
  try {
    const response = await fetch('/.netlify/functions/submit-lead', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(leadData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    // Track successful lead submission
    trackFormSubmission('contact_form', {
      lead_source: leadData.source || 'website',
      success: true
    });

    return { success: true, data: result };
  } catch (error) {
    console.error('Error submitting lead:', error);
    
    // Track failed lead submission
    trackFormSubmission('contact_form', {
      lead_source: leadData.source || 'website',
      success: false,
      error: error.message
    });
    
    return { success: false, error: error.message };
  }
};

// Geo location utilities
export const getUserLocation = async () => {
  try {
    const response = await fetch('/.netlify/functions/geo-hero');
    const data = await response.json();
    return data.city || 'Unknown';
  } catch (error) {
    console.error('Error getting user location:', error);
    return 'Unknown';
  }
};